import apiClient from './apiClient';

/**
 * Map API job to frontend shape (id, posted from createdAt).
 */
export const mapJobFromApi = (j) => {
  if (!j) return null;
  const id = j._id?.toString?.() ?? j.id;
  const createdAt = j.createdAt ? new Date(j.createdAt) : null;
  let posted = j.posted || '';
  if (createdAt && !j.posted) {
    const now = new Date();
    const diffMs = now - createdAt;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays === 0) posted = 'Today';
    else if (diffDays === 1) posted = '1 day ago';
    else if (diffDays < 7) posted = `${diffDays} days ago`;
    else if (diffDays < 30) posted = `${Math.floor(diffDays / 7)} week(s) ago`;
    else posted = `${Math.floor(diffDays / 30)} month(s) ago`;
  }
  return {
    id,
    _id: j._id,
    title: j.title || '',
    department: j.department || '',
    location: j.location || '',
    type: j.type || 'Full-time',
    experience: j.experience || '',
    salary: j.salary || '',
    posted,
    skills: Array.isArray(j.skills) ? j.skills : [],
    description: j.description || '',
    isActive: j.isActive !== false,
    createdAt: j.createdAt,
    updatedAt: j.updatedAt,
  };
};

/** Get all active job openings (public – no auth) */
export const getJobOpenings = async () => {
  const { data } = await apiClient.get('/api/job-openings');
  return Array.isArray(data) ? data.map(mapJobFromApi) : [];
};

/** Get all job openings for admin (includes inactive) */
export const getJobOpeningsAdmin = async () => {
  const { data } = await apiClient.get('/api/job-openings/admin');
  return Array.isArray(data) ? data.map(mapJobFromApi) : [];
};

/** Create job opening (admin) */
export const createJobOpening = async (payload) => {
  const { data } = await apiClient.post('/api/job-openings', payload);
  return mapJobFromApi(data);
};

/** Update job opening (admin) */
export const updateJobOpening = async (id, payload) => {
  const { data } = await apiClient.put(`/api/job-openings/${id}`, payload);
  return mapJobFromApi(data);
};

/** Delete job opening (admin) */
export const deleteJobOpening = async (id) => {
  await apiClient.delete(`/api/job-openings/${id}`);
};
